import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Form, Container, Row, Col, Pagination, Alert, Navbar, Image } from 'react-bootstrap';
import { FaArrowLeft, FaPlus, FaEdit, FaTrash, FaClipboardList } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from "../Images/gd.png";
import { IoReturnUpBack } from "react-icons/io5";

const Menuitems = () => {
    const navigate = useNavigate();
    const [inputValue, setInputValue] = useState('');
    const [menuItems, setMenuItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    useEffect(() => {
        fetchMenuItems();
    }, []);

    const fetchMenuItems = () => {
        axios.get('https://gwcapi.emedha.in/pages/api/api/menu-items')
            .then(response => setMenuItems(response.data))
            .catch(error => alert('Error fetching menu items!'));
    };

    const handleBack = () => navigate(-1);

    const handleAddMenuItem = async () => {
        if (!inputValue.trim()) {
            alert('Please enter a valid menu item!');
            return;
        }
        try {
            await axios.post('https://gwcapi.emedha.in/pages/api/api/menu-items', { item_name: inputValue });
            fetchMenuItems();
            setInputValue('');
        } catch (error) {
            alert('Error adding menu item!');
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://gwcapi.emedha.in/pages/api/api/menu-items/${id}`);
            fetchMenuItems();
        } catch (error) {
            alert('Error deleting menu item!');
        }
    };

    const handleUpdate = (id) => {
        const updatedItem = prompt('Edit Menu Item:', menuItems.find(item => item.id === id)?.item_name);
        if (updatedItem) {
            axios.put(`https://gwcapi.emedha.in/pages/api/api/menu-items/${id}`, { item_name: updatedItem })
                .then(fetchMenuItems)
                .catch(() => alert('Error updating menu item!'));
        }
    };

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = menuItems.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(menuItems.length / itemsPerPage);

    return (
        <div style={{ 
            minHeight: "100vh", 
            display: "flex", 
            flexDirection: "column", 
            background: "linear-gradient(135deg, #4B0082, #FFD700)", 
            color: "white" }}>
            
            {/* Navbar */}
            <div style={{ 
            minHeight: "100vh", }}>
            <Navbar className="dashboard-navbar">
        <Container fluid>
          <Navbar.Brand href="#" className="d-flex align-items-center">
            <Image src={Logo} alt="Golden Women" className="logo-img1" />
          
          </Navbar.Brand>
          <span className="brand-text">Golden Women</span>
          <IoReturnUpBack className="logout-icon" size={30} onClick={handleBack} />
        </Container>
      </Navbar>

            {/* Main Content */}
            <Container className="py-4">
                <Row className="mb-4">
                    <Col md={8}>
                        <h2 className="fw-bold">Manage Menu Items <FaClipboardList /></h2>
                        <p>Use this to add, update, or remove menu items.</p>
                    </Col>
                </Row>

                {/* Add Menu Item Section */}
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Control
                            type="text"
                            placeholder="Enter menu item"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleAddMenuItem()}
                            className="shadow-sm"
                        />
                    </Col>
                    <Col md={2}>
                        <Button variant="warning" className="w-100 shadow-sm" onClick={handleAddMenuItem}>
                            <FaPlus /> Add
                        </Button>
                    </Col>
                </Row>

                {/* Menu Items Table */}
                <Row>
                    <Col>
                        <Table striped bordered hover variant="dark" className="shadow-sm">
                            <thead>
                                <tr className="text-center">
                                    <th>#</th>
                                    <th>Menu Item</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => (
                                        <tr key={item.id} className="text-center">
                                            <td>{indexOfFirstItem + index + 1}</td>
                                            <td>{item.item_name}</td>
                                            <td>
                                                <Button variant="outline-info" size="sm" onClick={() => handleUpdate(item.id)} className="me-2">
                                                    <FaEdit />
                                                </Button>
                                                <Button variant="outline-danger" size="sm" onClick={() => handleDelete(item.id)}>
                                                    <FaTrash />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center text-warning">No menu items available</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>

                {/* Pagination */}
                {totalPages > 1 && (
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <Pagination>
                                <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
                                {[...Array(totalPages)].map((_, index) => (
                                    <Pagination.Item key={index} active={currentPage === index + 1} onClick={() => setCurrentPage(index + 1)}>
                                        {index + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
                            </Pagination>
                        </Col>
                    </Row>
                )}
            </Container>
            </div>

            {/* Footer */}
            <footer className="text-center py-3" style={{ 
        backgroundColor: "#4B0082", 
        width: "100%", 
        position: "relative", 
        bottom: 0 
    }}>
   
        
        <p className="mb-0">&copy; 2025 EMedha Technologies. All rights reserved.</p>
    </footer>
        </div>
    );
};

export default Menuitems;
